import Button from "../Button/Button";
import Icon, {editIcon, statusSentIcon, trashIcon} from "../Icon/Icon";

import "./Actions.scss"

const Actions = ({onSend, onEdit, onDelete}) => {
    return (
        <div className="actions">
            {onSend && (
                <Button variant="action" onClick={onSend}>
                    <Icon svg={statusSentIcon} className="sent"/>
                </Button>
            )}

            {onEdit && (
                <Button variant="action" onClick={onEdit}>
                    <Icon svg={editIcon} className="edit"/>
                </Button>
            )}

            {onDelete && (
                <Button variant="action" onClick={onDelete}>
                    <Icon svg={trashIcon} className="trash"/>
                </Button>
            )}
        </div>
    );
}

export default Actions;